import React from 'react';
import './ConstructionManagement.css';
import { Link } from 'react-router-dom';
import useScrollToTop from './useScrollToTop';
import ReusableLanding from './ReusableLanding';
import image2 from '../img/kitchen_modern_classic.png';
import { FaFileInvoice, FaBoxes, FaTruckLoading, FaWarehouse, FaRecycle, FaCalculator, FaClock, FaChartLine, FaSearch, FaDolly, FaListAlt, FaCheckCircle } from 'react-icons/fa'; // Import relevant icons

const MaterialManagementInventory = () => {
    useScrollToTop();
    return (
        <>
            <ReusableLanding
                imageUrl={image2}
                title="Material Management & Inventory"
                description="Efficient material management is crucial for project success. At Housekaar, we implement robust material management and inventory systems to ensure timely delivery and minimize waste."
            />
            <div className="management-page">

                <section className="services-overview">
                    <h2>Our Material Management Services</h2>
                    <p>We offer comprehensive material management services to optimize resource utilization and ensure smooth project execution.</p>
                    <ul className="services-list">
                        <li><FaFileInvoice className="service-icon" /> <strong>Procurement Planning:</strong> Developing detailed material procurement plans based on project specifications, quantities, and timelines.</li>
                        <li><FaBoxes className="service-icon" /> <strong>Inventory Tracking:</strong> Implementing systems for monitoring material inventory levels, tracking usage, and managing stock on-site and in storage.</li>
                        <li><FaTruckLoading className="service-icon" /> <strong>Supplier Management:</strong> Establishing and maintaining strong relationships with reliable suppliers and vendors to ensure timely delivery and competitive pricing.</li>
                        <li><FaWarehouse className="service-icon" /> <strong>Material Storage:</strong> Implementing best practices for the proper storage, handling, and protection of materials on the construction site to prevent damage and loss.</li>
                        <li><FaRecycle className="service-icon" /> <strong>Waste Reduction:</strong> Implementing strategies and processes to minimize material waste through careful planning, efficient usage, and proper disposal or recycling.</li>
                    </ul>
                </section>

                <section className="benefits-section">
                    <h2>Benefits of Material Management</h2>
                    <ul className="benefits-list">
                        <li className="card">
                            <div className="benefit-icon"><FaCalculator /></div>
                            <h3>Cost Savings</h3>
                            <p>Reducing overall material costs through efficient procurement, minimized waste, and accurate inventory control.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaClock /></div>
                            <h3>Timely Delivery</h3>
                            <p>Ensuring that the right materials are available at the right place and at the right time, preventing project delays.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaChartLine /></div>
                            <h3>Improved Efficiency</h3>
                            <p>Streamlining material management processes, reducing manual effort, and improving overall project workflow.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaSearch /></div>
                            <h3>Reduced Delays</h3>
                            <p>Minimizing the risk of project delays caused by material shortages, misplacements, or procurement issues.</p>
                        </li>
                    </ul>
                </section>

                <section className="process-section">
                    <h2>Our Process</h2>
                    <p>Our systematic approach ensures effective material management throughout your project lifecycle.</p>
                    <ol className="process-list">
                        <li><FaListAlt className="process-icon" /> <strong>Planning:</strong> Developing comprehensive material procurement plans, inventory management strategies, and supplier selection criteria.</li>
                        <li><FaDolly className="process-icon" /> <strong>Procurement:</strong> Efficiently procuring materials from pre-qualified and reliable suppliers, negotiating favorable terms, and managing purchase orders.</li>
                        <li><FaBoxes className="process-icon" /> <strong>Tracking:</strong> Implementing robust inventory tracking systems to monitor material receipt, storage, issuance, and usage on the construction site.</li>
                        <li><FaWarehouse className="process-icon" /> <strong>Management:</strong> Ensuring proper material storage, handling procedures, and regular inventory audits to minimize loss and optimize availability.</li>
                        <li><FaCheckCircle className="process-icon" /> <strong>Optimization:</strong> Continuously monitoring material usage, identifying opportunities for waste reduction, and refining procurement and inventory strategies.</li>
                    </ol>
                </section>

                <section className="get-started-cta">
                    <h2>Optimize Your Material Usage and Project Efficiency</h2>
                    <p>
                        Contact us today to learn more about our comprehensive material management and inventory services. Let us help you streamline your material processes and achieve significant project benefits.
                    </p>
                    <Link to="/pricing">
                        <button className="custom-button">Contact Us</button>
                    </Link>
                </section>
            </div>
        </>
    );
};

export default MaterialManagementInventory;